import { FormControlLabel } from "@material-ui/core";
import { withStyles } from "@material-ui/core";

export const StyledFormControl = withStyles({
  label: { color: "#2699fb" },
})(FormControlLabel);
